import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { XIcon, ArrowRightIcon, SparklesIcon } from 'lucide-react';
export interface Room {
  id: string;
  name: string;
  tagline: string;
  blurb: string;
  description: string;
  features: string[];
  image: string;
}
interface Props {
  room: Room | null;
  onClose: () => void;
}
export function RoomDetail({
  room,
  onClose
}: Props) {
  return <AnimatePresence data-id="element-158">
      {room && <motion.div initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} exit={{
      opacity: 0
    }} transition={{
      duration: 0.4
    }} className="fixed inset-0 z-[200] flex items-center justify-center p-4 md:p-8" data-id="element-159">
          <div className="absolute inset-0 bg-aubergine-900/85 backdrop-blur-md" onClick={onClose} data-id="element-160" />

          <motion.div initial={{
        opacity: 0,
        y: 30,
        scale: 0.97
      }} animate={{
        opacity: 1,
        y: 0,
        scale: 1
      }} exit={{
        opacity: 0,
        y: 20,
        scale: 0.98
      }} transition={{
        duration: 0.55,
        ease: [0.25, 0.1, 0.25, 1]
      }} className="relative z-10 bg-cream-50 max-w-2xl w-full max-h-[90vh] overflow-y-auto rounded-sm border border-gold-400/30 shadow-2xl" data-id="element-161">
            <button onClick={onClose} aria-label="Close" className="absolute top-4 right-4 z-20 w-10 h-10 rounded-full bg-cream-50/90 backdrop-blur flex items-center justify-center hover:bg-lilac-100 transition-colors" data-id="element-162">
              <XIcon size={18} strokeWidth={1.4} className="text-ink" data-id="element-163" />
            </button>

            {/* Header band — aubergine + gold to match brand */}
            <div className="relative bg-aubergine-800 px-10 lg:px-14 pt-12 pb-10 overflow-hidden" data-id="element-164">
              <div className="absolute inset-0 opacity-30 pointer-events-none" style={{
            background: 'radial-gradient(ellipse at 30% 20%, rgba(224,196,126,0.4), transparent 60%)'
          }} data-id="element-165" />
              <div className="relative" data-id="element-166">
                <div className="flex items-center gap-3 mb-5" data-id="element-167">
                  <SparklesIcon size={14} className="text-gold-300" data-id="element-168" />
                  <span className="text-[10px] uppercase tracking-luxe text-gold-300" data-id="element-169">
                    {room.tagline}
                  </span>
                </div>
                <h2 className="font-serif text-4xl md:text-5xl text-cream-50 leading-[1.02]" data-id="element-170">
                  {room.name}
                </h2>
                <p className="font-serif italic text-lg text-gold-300/90 mt-3" data-id="element-171">
                  {room.blurb}
                </p>
              </div>
            </div>

            <div className="p-10 lg:p-14" data-id="element-172">
              <p className="text-base text-ink/75 leading-relaxed font-light mb-8" data-id="element-173">
                {room.description}
              </p>

              <ul className="space-y-3 mb-10" data-id="element-174">
                {room.features.map(f => <li key={f} className="flex items-start gap-3 text-sm text-ink/75 font-light" data-id="element-175">
                    <span className="mt-2 h-px w-4 bg-gold-400 flex-shrink-0" data-id="element-176" />
                    {f}
                  </li>)}
              </ul>

              <a href="#visit" onClick={onClose} className="group w-full inline-flex items-center justify-center gap-2 px-8 py-4 bg-aubergine-800 text-cream-50 rounded-full text-[11px] uppercase tracking-luxe hover:bg-aubergine-700 transition-colors duration-500" data-id="element-177">
                Reserve This Service
                <ArrowRightIcon size={14} className="group-hover:translate-x-1 transition-transform" data-id="element-178" />
              </a>
            </div>
          </motion.div>
        </motion.div>}
    </AnimatePresence>;
}